module.exports = __webpack_public_path__ + "static/media/matt-palmer.d7f6ce6d.jpg";